import dynamic from "next/dynamic";

export const DynamicContent069 = dynamic(() => import("./Content069"), {
  suspense: true,
});
